import 'lazysizes';
import '../Helper';
import { attachAnalyticsTracking } from '../Helper/analytics-tracking';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import './Presentation/Atom/Arrow/Arrow';
import './Presentation/Atom/CustomCursor/CustomCursor';
import './Presentation/Atom/Video/Video';
import './Presentation/Atom/RichText/RichText';
import './Presentation/Atom/TelephoneLink/TelephoneLink';
import './Presentation/Atom/TextSlider/TextSlider';
import './Presentation/Molecule/AnimatedBackground/AnimatedBackground';
import './Presentation/Molecule/CookieConsent/CookieConsent';
import './Presentation/Molecule/LogoSlider/LogoSlider';
import './Presentation/Molecule/MobilePhotoSwipe/MobilePhotoSwipe';
import './Presentation/Molecule/PageSlider/PageSlider';
import './Presentation/Molecule/ShiftImages/ShiftImages';
import './Presentation/Molecule/Stat/Stat';
import './Presentation/Molecule/TutorialHint/TutorialHint';
import './Presentation/Molecule/TutorialNavigation/TutorialNavigation';
import './Presentation/Molecule/Slider/Slider';
import './Presentation/Molecule/SplitView/SplitView';
import './Presentation/Molecule/YoutubePlayer/YoutubePlayer';
import './Presentation/Molecule/Map/Map';
import './Presentation/Organism/ArchiveWall/ArchiveWall';
import './Presentation/Organism/MosaicDrift/MosaicDrift';
import './Presentation/Organism/BrowserMockup/BrowserMockup';
import { attachNewsletterSignUpForms } from './Presentation/Organism/BrevoNewsletterSignUpForm/BrevoNewsletterSignUpForm';
import { attachNewsletterConfirmationConfetti } from './Presentation/Organism/NewsletterConfirmation/NewsletterConfirmation';
import './Presentation/Organism/FooterLarge/FooterLarge';
import './Presentation/Organism/Header/Header';
import './Presentation/Organism/Hero/Hero';
import './Presentation/Organism/StackedMemoryLayers/StackedMemoryLayers';
import './Presentation/Organism/TeamIntroduction/TeamIntroduction';
import './Presentation/Organism/TeaserCardGrid/TeaserCardGrid';
import './Presentation/Organism/TiltedFilmStrip/TiltedFilmStrip';
import './Presentation/Organism/TimeTunnel/TimeTunnel';
import './Presentation/Organism/WebsiteEvolution/WebsiteEvolution';

Alpine.plugin(focus);
Alpine.plugin(collapse);

// We use this to enable the AlpineJS debugger in the browser.
if (!document.documentElement.dataset.debug) {
    window.Alpine = Alpine;
}

// Safari 11 polyfill for AlpineJS, see also https://github.com/alpinejs/alpine/discussions/1964
if (typeof window.queueMicrotask !== 'function') {
    window.queueMicrotask = function (callback) {
        Promise.resolve()
            .then(callback)
            .catch((e) =>
                setTimeout(() => {
                    throw e;
                })
            );
    };
}

Alpine.start();

if (!document.body.classList.contains('neos-backend')) {
    attachNewsletterConfirmationConfetti();
    attachNewsletterSignUpForms();
    attachAnalyticsTracking();
}
